import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../CTAButton';
export function UpsellHero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="bg-[#EDE4D6]/50 backdrop-blur-[2px] pt-0 pb-20 md:pb-28 relative overflow-hidden" data-id="element-356">
      {/* Eye-catching top banner */}
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-gradient-to-r from-terracotta via-terracotta-dark to-terracotta text-white text-center py-4 px-4 relative overflow-hidden" data-id="element-357">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.1) 10px, rgba(255,255,255,0.1) 20px)'
      }} data-id="element-358" />
        <motion.p animate={{
        scale: [1, 1.03, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="text-lg md:text-2xl font-heading font-bold tracking-wide relative z-10" data-id="element-359">
          🔥 ¿TE IRÁS SIN ANTES VER ESTO? 🔥
        </motion.p>
      </motion.div>

      <div className="container mx-auto px-6 max-w-3xl text-center relative z-10 pt-16 md:pt-20" data-id="element-360">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" data-id="element-361">
          <motion.div variants={itemVariants} className="mb-8" data-id="element-362">
            <span className="inline-block px-6 py-2.5 rounded-full bg-sage text-white text-base md:text-lg font-bold tracking-widest uppercase shadow-lg" data-id="element-363">
              ⭐ Oferta Exclusiva ⭐
            </span>
          </motion.div>

          <motion.h1 variants={itemVariants} className="text-4xl md:text-5xl font-heading font-semibold text-text-dark leading-tight mb-6" data-id="element-364">
            Haz tu plan mucho más fácil y efectivo
          </motion.h1>

          <motion.p variants={itemVariants} className="text-xl text-text-medium mb-6 font-medium leading-relaxed" data-id="element-365">
            Añade estas guías complementarias que te ayudarán a aplicar el plan
            de forma más simple, práctica y deliciosa.
          </motion.p>

          <motion.p variants={itemVariants} className="text-lg text-text-medium/80 mb-10" data-id="element-366">
            Miles de personas que compran el programa también agregan estos
            recursos para obtener mejores resultados.
          </motion.p>

          <motion.div variants={itemVariants} data-id="element-367">
            <CTAButton text="Quiero los bonos" variant="primary" href="#bonos" data-id="element-368" />
          </motion.div>
        </motion.div>
      </div>

      {/* Decorative divider */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-sage/20 rounded-full" data-id="element-369"></div>
    </section>;
}